var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { useModel as _useModel, mergeModels as _mergeModels, defineComponent as _defineComponent } from 'vue';
import { withKeys as _withKeys, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, renderSlot as _renderSlot, createBlock as _createBlock, withModifiers as _withModifiers, mergeProps as _mergeProps, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
var _withScopeId = function (n) { return (_pushScopeId("data-v-09691180"), n = n(), _popScopeId(), n); };
var _hoisted_1 = ["aria-checked", "aria-disabled"];
var _hoisted_2 = ["id", "disabled", "name"];
var _hoisted_3 = ["aria-hidden"];
var _hoisted_4 = ["aria-hidden"];
var _hoisted_5 = ["for"];
var _hoisted_6 = { class: "flex items-center space-x-2.5" };
import { computed, nextTick, onMounted, ref, toRef, useSlots } from 'vue';
import EHelp from '@common/ui/EHelp.vue';
import EError from '@common/ui/EError/EError.vue';
import { generateUuid } from '@common/utils/Helpers/Helpers';
export default /*#__PURE__*/ _defineComponent(__assign({
    inheritAttrs: false
}, { __name: 'ESwitch', props: /*#__PURE__*/ _mergeModels({
        name: { default: '' },
        disabled: { type: Boolean, default: false },
        width: { default: 40 },
        activeIconClass: { default: '' },
        inactiveIconClass: { default: '' },
        activeText: {},
        inactiveText: {},
        activeColor: { default: '' },
        inactiveColor: { default: '' },
        id: {},
        label: {},
        labelable: { type: Boolean },
        helpText: {},
        hideError: { type: Boolean },
        position: {},
        rule: {},
        validateOnMount: { type: Boolean }
    }, {
        "modelValue": { required: true, default: false },
        "modelModifiers": {},
    }), emits: /*#__PURE__*/ _mergeModels(["change"], ["update:modelValue"]), setup: function (__props, _a) {
        var _this = this;
        var __emit = _a.emit;
        var emit = __emit;
        var props = __props;
        var valueModel = _useModel(__props, "modelValue");
        var isErrored = ref(false);
        var slots = useSlots();
        var coreRef = ref();
        var coreWidth = toRef(props, 'width');
        var name = toRef(props, 'name');
        var inputId = computed(function () { return props.id || props.name || generateUuid(); });
        var handleSwitch = function () { return __awaiter(_this, void 0, void 0, function () {
            var val;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (props.disabled)
                            return [2 /*return*/];
                        val = !valueModel.value;
                        valueModel.value = val;
                        return [4 /*yield*/, nextTick()];
                    case 1:
                        _a.sent();
                        emit('change', val);
                        if (props.activeColor || props.inactiveColor) {
                            setBackgroundColor();
                        }
                        return [2 /*return*/];
                }
            });
        }); };
        var setBackgroundColor = function () {
            var newColor = valueModel.value ? props.activeColor : props.inactiveColor;
            coreRef.value.style.borderColor = newColor;
            coreRef.value.style.backgroundColor = newColor;
        };
        onMounted(function () {
            if (props.activeColor || props.inactiveColor) {
                setBackgroundColor();
            }
        });
        return function (_ctx, _cache) {
            return (_openBlock(), _createBlock(EError, {
                "hide-error": _ctx.hideError,
                name: name.value,
                position: _ctx.position,
                rule: _ctx.rule,
                "validate-on-mount": _ctx.validateOnMount,
                value: valueModel.value,
                class: "!w-auto flex",
                onChangeErrorStatus: _cache[0] || (_cache[0] = function ($event) { return (isErrored.value = $event); })
            }, {
                default: _withCtx(function () { return [
                    _createElementVNode("div", _mergeProps({ class: "inline-flex items-center" }, _ctx.$attrs, {
                        onClick: _withModifiers(handleSwitch, ["prevent"])
                    }), [
                        _createElementVNode("div", {
                            "aria-checked": valueModel.value,
                            "aria-disabled": _ctx.disabled,
                            class: _normalizeClass([{ 'is-disabled': _ctx.disabled, 'is-checked': valueModel.value }, "e-switch"]),
                            role: "switch"
                        }, [
                            _createElementVNode("input", {
                                id: inputId.value,
                                ref: "inputRef",
                                disabled: _ctx.disabled,
                                name: name.value,
                                class: "e-switch__input",
                                type: "checkbox",
                                onChange: handleSwitch,
                                onKeydown: _withKeys(handleSwitch, ["enter"])
                            }, null, 40, _hoisted_2),
                            (_ctx.inactiveIconClass || _ctx.inactiveText)
                                ? (_openBlock(), _createElementBlock("span", {
                                    key: 0,
                                    class: _normalizeClass([[!valueModel.value ? 'is-active' : ''], "e-switch__label e-switch__label--left"])
                                }, [
                                    (_ctx.inactiveIconClass)
                                        ? (_openBlock(), _createElementBlock("i", {
                                            key: 0,
                                            class: _normalizeClass([_ctx.inactiveIconClass])
                                        }, null, 2))
                                        : _createCommentVNode("", true),
                                    (!_ctx.inactiveIconClass && _ctx.inactiveText)
                                        ? (_openBlock(), _createElementBlock("span", {
                                            key: 1,
                                            "aria-hidden": valueModel.value
                                        }, _toDisplayString(_ctx.inactiveText), 9, _hoisted_3))
                                        : _createCommentVNode("", true)
                                ], 2))
                                : _createCommentVNode("", true),
                            _createElementVNode("span", {
                                ref_key: "coreRef",
                                ref: coreRef,
                                style: _normalizeStyle({ 'width': coreWidth.value + 'px' }),
                                class: "e-switch__core"
                            }, null, 4),
                            (_ctx.activeIconClass || _ctx.activeText)
                                ? (_openBlock(), _createElementBlock("span", {
                                    key: 1,
                                    class: _normalizeClass([[valueModel.value ? 'is-active' : ''], "e-switch__label e-switch__label--right"])
                                }, [
                                    (_ctx.activeIconClass)
                                        ? (_openBlock(), _createElementBlock("i", {
                                            key: 0,
                                            class: _normalizeClass([_ctx.activeIconClass])
                                        }, null, 2))
                                        : _createCommentVNode("", true),
                                    (!_ctx.activeIconClass && _ctx.activeText)
                                        ? (_openBlock(), _createElementBlock("span", {
                                            key: 1,
                                            "aria-hidden": !valueModel.value
                                        }, _toDisplayString(_ctx.activeText), 9, _hoisted_4))
                                        : _createCommentVNode("", true)
                                ], 2))
                                : _createCommentVNode("", true)
                        ], 10, _hoisted_1),
                        _createElementVNode("label", {
                            for: _ctx.labelable ? inputId.value : undefined,
                            class: "ml-2.5 cursor-pointer"
                        }, [
                            _renderSlot(_ctx.$slots, "default", {}, function () { return [
                                _createElementVNode("div", _hoisted_6, [
                                    _createElementVNode("p", null, _toDisplayString(_ctx.label), 1),
                                    (_ctx.helpText)
                                        ? (_openBlock(), _createBlock(EHelp, {
                                            key: 0,
                                            text: _ctx.helpText
                                        }, null, 8, ["text"]))
                                        : _createCommentVNode("", true)
                                ])
                            ]; })
                        ], 8, _hoisted_5)
                    ], 16)
                ]; }),
                _: 3
            }, 8, ["hide-error", "name", "position", "rule", "validate-on-mount", "value"]));
        };
    } }));
